module.exports = __webpack_public_path__ + "static/media/03.9e9124d0.png";